import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

import { api, useAlCambiar, useDatos } from "./api";
import { Entrar } from "./pantallas/Entrar";
import type { Sesion } from "./tipos";

const Contexto = createContext<{ sesion: Sesion | undefined; recargar: () => void; salir: () => Promise<void> }>({
  sesion: undefined,
  recargar: () => undefined,
  salir: async () => undefined,
});

/* Pide la sesión y, si el servidor contesta 401 (acá o en cualquier otro pedido), muestra el
 * inicio de sesión en lugar del panel. */
export function SesionProvider({ children }: { children: ReactNode }) {
  const { datos, cargando, recargar, setDatos } = useDatos<Sesion>("/api/sesion");
  const [sinSesion, setSinSesion] = useState(false);
  useAlCambiar(recargar);

  useEffect(() => {
    const oyente = () => setSinSesion(true);
    window.addEventListener("prospeccion:sin-sesion", oyente);
    return () => window.removeEventListener("prospeccion:sin-sesion", oyente);
  }, []);

  useEffect(() => {
    if (datos) setSinSesion(false);
  }, [datos]);

  const salir = async () => {
    await api("/api/sesion/salir", { metodo: "POST" }).catch(() => undefined);
    setDatos(undefined);
    setSinSesion(true);
  };

  if (sinSesion) {
    return (
      <Entrar
        onEntro={() => {
          setSinSesion(false);
          recargar();
        }}
      />
    );
  }
  // Hasta saber si hay sesión no se monta el panel: evita un destello de la barra lateral y
  // una ráfaga de pedidos que van a dar 401.
  if (!datos && cargando) return null;
  return <Contexto.Provider value={{ sesion: datos, recargar, salir }}>{children}</Contexto.Provider>;
}

export const useSesion = () => useContext(Contexto);
